(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bff-banner-atmosphere"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bff-banner-atmosphere')) {
  customElements.define('bff-banner-atmosphere', class extends HTMLElement {
    connectedCallback() {
      this.image = this.parentElement.querySelector('picture img');
      if (!this.image) return;
      this.lifecycle = new AbortController();
      this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = true;
      this.frame = this.clock = this.lastFrame = 0;
      this.source = '';
      const options = { signal: this.lifecycle.signal };
      this.preference.addEventListener('change', () => {
        if (this.preference.matches) {
          this.pause();
          this.dataset.state = 'reduced-motion';
        } else this.loadArtwork();
      }, options);
      this.image.addEventListener('load', () => this.loadArtwork(), options);
      window.addEventListener('resize', () => {
        this.resize();
        this.loadArtwork();
      }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pause();
        else this.resume();
      }, options);
      this.visibilityObserver = new IntersectionObserver((entries) => {
        this.inView = entries[0].isIntersecting;
        if (this.inView) this.resume();
        else this.pause();
      });
      this.visibilityObserver.observe(this);
      this.sizeObserver = new ResizeObserver(() => this.resize());
      this.sizeObserver.observe(this);
      if (this.preference.matches) this.dataset.state = 'reduced-motion';
      else this.loadArtwork();
    }

    disconnectedCallback() {
      this.lifecycle?.abort();
      this.visibilityObserver?.disconnect();
      this.sizeObserver?.disconnect();
      this.pause();
      this.canvas?.remove();
      this.canvas = this.context = this.artwork = this.regions = null;
      this.source = '';
    }

    loadArtwork() {
      if (this.preference.matches || !this.image.complete || !this.image.naturalWidth) return;
      const source = this.image.currentSrc;
      const mobile = source.includes('4B99AE7B-ECDC-4CFA-86E9-905089BA72B6');
      const desktop = source.includes('ChatGPT_Image_Jul_4_2026_08_49_38_PM');
      if (!mobile && !desktop) {
        this.pause();
        this.source = '';
        this.dataset.state = 'static-artwork';
        return;
      }
      if (this.loadedSource === source && this.artwork) {
        this.dataset.state = 'ready';
        this.resize();
        this.resume();
        return;
      }
      if (this.source === source && this.dataset.state === 'loading') return;
      this.pause();
      this.source = source;
      this.dataset.state = 'loading';
      const artwork = new Image();
      artwork.onload = () => {
        if (!this.isConnected || this.source !== source) return;
        if (!this.canvas) {
          this.canvas = document.createElement('canvas');
          this.canvas.setAttribute('aria-hidden', 'true');
          this.context = this.canvas.getContext('2d', { alpha: true });
          if (!this.context) {
            this.dataset.state = 'static-fallback';
            return;
          }
          this.append(this.canvas);
        }
        this.artwork = artwork;
        this.mobileArtwork = mobile;
        this.loadedSource = source;
        this.dataset.state = this.preference.matches ? 'reduced-motion' : 'ready';
        this.resize();
        this.resume();
      };
      artwork.onerror = () => {
        if (this.source === source) {
          this.source = '';
          this.dataset.state = 'static-fallback';
        }
      };
      artwork.src = source;
    }

    createRegion(type, center, radius, bottom, fit) {
      const left = Math.max(0, center[0] - radius[0]);
      const top = Math.max(0, center[1] - radius[1]);
      const width = Math.min(1, center[0] + radius[0]) - left;
      const height = Math.min(1, center[1] + radius[1]) - top;
      const scale = Math.min(1, 480 / Math.max(width * fit.width * this.pixelRatio, height * fit.height * this.pixelRatio));
      const pixelWidth = Math.max(1, Math.round(width * fit.width * this.pixelRatio * scale));
      const pixelHeight = Math.max(1, Math.round(height * fit.height * this.pixelRatio * scale));
      const createCanvas = () => {
        const canvas = document.createElement('canvas');
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        return canvas;
      };
      const base = createCanvas();
      const mask = createCanvas();
      const output = createCanvas();
      base.getContext('2d').drawImage(this.artwork, left * this.artwork.naturalWidth, top * this.artwork.naturalHeight, width * this.artwork.naturalWidth, height * this.artwork.naturalHeight, 0, 0, pixelWidth, pixelHeight);
      const maskContext = mask.getContext('2d');
      maskContext.save();
      maskContext.translate((center[0] - left) / width * pixelWidth, (center[1] - top) / height * pixelHeight);
      maskContext.scale(radius[0] / width * pixelWidth, radius[1] / height * pixelHeight);
      const feather = maskContext.createRadialGradient(0, 0, 0.45, 0, 0, 1);
      feather.addColorStop(0, 'rgba(255,255,255,1)');
      feather.addColorStop(1, 'rgba(255,255,255,0)');
      maskContext.fillStyle = feather;
      maskContext.fillRect(-1, -1, 2, 2);
      maskContext.restore();
      maskContext.globalCompositeOperation = 'destination-in';
      const fade = maskContext.createLinearGradient(0, (bottom - 0.035 - top) / height * pixelHeight, 0, (bottom - top) / height * pixelHeight);
      fade.addColorStop(0, 'rgba(255,255,255,1)');
      fade.addColorStop(1, 'rgba(255,255,255,0)');
      maskContext.fillStyle = fade;
      maskContext.fillRect(0, 0, pixelWidth, pixelHeight);
      return { type, base, mask, output, context: output.getContext('2d'), x: fit.x + left * fit.width, y: fit.y + top * fit.height, width: width * fit.width, height: height * fit.height };
    }

    resize() {
      if (!this.context || !this.artwork) return;
      const rect = this.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      this.pixelRatio = Math.min(window.devicePixelRatio || 1, 1.5, Math.sqrt(900000 / (rect.width * rect.height)));
      this.canvas.width = Math.round(rect.width * this.pixelRatio);
      this.canvas.height = Math.round(rect.height * this.pixelRatio);
      this.context.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
      const scale = Math.max(rect.width / this.artwork.naturalWidth, rect.height / this.artwork.naturalHeight);
      const width = this.artwork.naturalWidth * scale;
      const height = this.artwork.naturalHeight * scale;
      const position = getComputedStyle(this.image).objectPosition.split(' ');
      const fraction = (value) => value?.endsWith('%') ? parseFloat(value) / 100 : 0.5;
      const fit = { x: (rect.width - width) * fraction(position[0]), y: (rect.height - height) * fraction(position[1]), width, height };
      this.regions = this.mobileArtwork ? [
        this.createRegion('fire', [0.914, 0.409], [0.140, 0.084], 0.475, fit),
        this.createRegion('steam', [0.491, 0.474], [0.183, 0.139], 0.603, fit)
      ] : [
        this.createRegion('fire', [0.874, 0.130], [0.145, 0.215], 0.285, fit),
        this.createRegion('steam', [0.548, 0.220], [0.140, 0.230], 0.423, fit)
      ];
      this.renderScene();
    }

    renderScene() {
      if (!this.regions) return;
      const main = this.context;
      main.clearRect(0, 0, this.canvas.width / this.pixelRatio, this.canvas.height / this.pixelRatio);
      for (const region of this.regions) {
        const context = region.context;
        const width = region.output.width;
        const height = region.output.height;
        const time = this.clock;
        context.globalCompositeOperation = 'source-over';
        context.globalAlpha = 1;
        context.clearRect(0, 0, width, height);
        if (region.type === 'fire') {
          const shimmer = Math.min(4, width * 0.013);
          context.filter = `brightness(${1 + Math.sin(time * 5.1) * 0.035 + Math.sin(time * 8.7) * 0.018})`;
          for (let y = 0; y < height; y += 3) {
            const band = Math.min(3, height - y);
            const shift = (Math.sin(y / height * 13 - time * 4.9) + Math.sin(y / height * 23 - time * 7.1) * 0.4) * shimmer;
            context.drawImage(region.base, 0, y, width, band, shift, y, width, band + 0.25);
          }
          context.filter = 'none';
        } else {
          const phaseA = (time / 8) % 1;
          const phaseB = (time / 8 + 0.5) % 1;
          const blend = 0.5 - 0.5 * Math.cos(phaseA * Math.PI * 2);
          const rise = height * 0.15;
          const drift = Math.sin(time * 0.8) * Math.min(4, width * 0.025);
          context.drawImage(region.base, drift * 0.7, -phaseB * rise);
          context.globalAlpha = blend;
          context.drawImage(region.base, drift, -phaseA * rise);
          context.globalAlpha = 1;
        }
        context.globalCompositeOperation = 'destination-in';
        context.drawImage(region.mask, 0, 0);
        main.globalAlpha = region.type === 'steam' ? 0.88 : 1;
        main.drawImage(region.output, region.x, region.y, region.width, region.height);
      }
      main.globalAlpha = 1;
    }

    resume() {
      if (!this.context || this.frame || !this.inView || document.hidden || this.preference.matches || this.dataset.state !== 'ready') return;
      this.lastFrame = 0;
      this.frame = requestAnimationFrame((time) => this.draw(time));
    }

    draw(time) {
      this.frame = 0;
      if (!this.inView || document.hidden || this.preference.matches || this.dataset.state !== 'ready') return;
      if (!this.lastFrame || time - this.lastFrame >= 1000 / 30) {
        this.clock += this.lastFrame ? Math.min((time - this.lastFrame) / 1000, 0.1) : 0;
        this.lastFrame = time;
        this.renderScene();
      }
      this.frame = requestAnimationFrame((nextTime) => this.draw(nextTime));
    }

    pause() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.lastFrame = 0;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
